"use client";
import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import Icon from "./icon.js";
export const StarCircleFillIcon = React.forwardRef(function StarCircleFillIcon(props, ref) {
    return (_jsx(Icon, Object.assign({ ref: ref, strokeWidth: "0" }, props, { children: _jsx("path", { d: "M12 1c6.075 0 11 4.925 11 11s-4.925 11-11 11S1 18.075 1 12 5.925 1 12 1zm-.679 6.431l-1.144 2.436-2.541.391-.103.023a.75.75 0 0 0-.32 1.242l1.86 1.905-.44 2.701-.01.101a.75.75 0 0 0 1.113.676L12 15.654l2.264 1.252.092.044a.75.75 0 0 0 1.011-.821l-.441-2.701 1.861-1.905.068-.08a.75.75 0 0 0-.491-1.185l-2.542-.391-1.143-2.436a.75.75 0 0 0-1.358 0z", fill: "currentColor" }) })));
});
export default StarCircleFillIcon;
//# sourceMappingURL=star-circle-fill.js.map